module.exports = __webpack_public_path__ + "static/media/screenshot-scenarios-step-1.1db05c02.png";